{
  "accordion": {
    "blurb": "Một tập hợp các tiêu đề tương tác xếp chồng theo chiều dọc, mỗi tiêu đề hiển thị một phần nội dung.",
    "contentOne": "Có. Nó tuân thủ mẫu thiết kế WAI-ARIA.",
    "contentThree": "Có. Nó có hoạt ảnh theo mặc định, nhưng bạn có thể tắt nếu muốn.",
    "contentTwo": "Có. Nó đi kèm với kiểu mặc định phù hợp với tính thẩm mỹ của các thành phần khác.",
    "name": "Accordion",
    "triggerOne": "Nó có thể truy cập được không?",
    "triggerThree": "Nó có hoạt ảnh không?",
    "triggerTwo": "Nó có được tạo kiểu không?"
  },
  "alert": {
    "actionCta": "Hoàn tác",
    "actionTitle": "Các email đã chọn đã được đánh dấu là spam.",
    "blurb": "Thông báo để thu hút sự chú ý của người dùng.",
    "errorDescription": "Vui lòng xác minh thông tin thanh toán của bạn và thử lại.<ul><li>Kiểm tra chi tiết thẻ của bạn</li><li>Xác minh địa chỉ thanh toán</li></ul>",
    "errorDescriptionNative": "Vui lòng xác minh thông tin thanh toán của bạn và thử lại.",
    "errorTitle": "Không thể xử lý thanh toán của bạn.",
    "extendedDescription": "Đây là mô tả dài tương tự chứa thông tin chi tiết về cảnh báo. Nó cho thấy thành phần có thể chứa nội dung mở rộng trong khi vẫn bảo tồn khoảng cách, căn chỉnh và khả năng đọc phù hợp trên các kích thước màn hình và độ rộng khung nhìn khác nhau. Điều này giúp đảm bảo trải nghiệm người dùng vẫn nhất quán bất kể độ dài nội dung.",
    "extendedTitle": "Đây là tiêu đề cảnh báo cực kỳ dài trải dài nhiều dòng để chứng minh cách thành phần xử lý các tiêu đề rất dài trong khi vẫn duy trì khả năng đọc và hành vi ngắt dòng văn bản phù hợp",
    "name": "Cảnh báo",
    "noDescTitle": "Cảnh báo này không có mô tả.",
    "successDescription": "Đây là cảnh báo với biểu tượng, tiêu đề và mô tả.",
    "successTitle": "Thành công! Các thay đổi của bạn đã được lưu"
  },
  "alertDialog": {
    "blurb": "Hộp thoại modal làm gián đoạn người dùng với nội dung quan trọng và mong đợi phản hồi.",
    "description": "Hành động này không thể hoàn tác. Điều này sẽ xóa vĩnh viễn tài khoản của bạn và xóa dữ liệu của bạn khỏi máy chủ của chúng tôi.",
    "name": "Hộp thoại Cảnh báo",
    "title": "Bạn có hoàn toàn chắc chắn không?",
    "trigger": "Hiện hộp thoại"
  },
  "avatar": {
    "blurb": "Thành phần hình ảnh có đại diện thay thế để mô tả người dùng.",
    "name": "Avatar"
  },
  "badge": {
    "blurb": "Thành phần đếm hoặc gắn nhãn nhỏ có thể được sử dụng để làm nổi bật các mục mới hoặc chưa đọc.",
    "default": "Mặc định",
    "destructive": "Phá hủy",
    "name": "Huy hiệu",
    "outline": "Viền",
    "secondary": "Phụ"
  },
  "blocks": {
    "title": "Khối"
  },
  "breadcrumbs": {
    "title": "Breadcrumb"
  },
  "button": {
    "blurb": "Phần tử có thể nhấp thực hiện hành động khi được nhấn.",
    "default": "Mặc định",
    "destructive": "Phá hủy",
    "disabled": "Vô hiệu hóa",
    "ghost": "Ma",
    "large": "Lớn",
    "learnMore": "Tìm hiểu thêm",
    "link": "Liên kết",
    "loading": "Đang tải...",
    "name": "Nút",
    "outline": "Viền",
    "secondary": "Phụ",
    "send": "Gửi",
    "small": "Nhỏ"
  },
  "card": {
    "image": {
      "description": "Đây là thẻ có hình ảnh.",
      "title": "Thẻ hình ảnh"
    },
    "login": {
      "cta": "Đăng nhập",
      "ctaGoogle": "Đăng nhập bằng Google",
      "description": "Nhập email của bạn bên dưới để đăng nhập vào tài khoản của bạn",
      "emailLabel": "Email",
      "emailPlaceholder": "toi@example.com",
      "forgotPassword": "Quên mật khẩu?",
      "noAccount": "Không có tài khoản? <a>Đăng ký</a>",
      "passwordLabel": "Mật khẩu",
      "title": "Đăng nhập vào tài khoản của bạn"
    },
    "meetingNotes": {
      "description": "Bản ghi từ cuộc họp với khách hàng.",
      "title": "Ghi chú cuộc họp"
    },
    "meta": {
      "content": "Nội dung",
      "contentOnly": "Chỉ nội dung",
      "footer": "Chân trang",
      "footerOnly": "Chỉ chân trang",
      "headerAndContentDescription": "Đây là thẻ có tiêu đề và nội dung.",
      "headerAndContentTitle": "Tiêu đề và nội dung",
      "headerAndFooterDescription": "Đây là thẻ có tiêu đề và chân trang.",
      "headerAndFooterTitle": "Tiêu đề và chân trang",
      "headerContentAndFooterDescription": "Đây là thẻ có tiêu đề, nội dung và chân trang.",
      "headerContentAndFooterTitle": "Tiêu đề, nội dung và chân trang",
      "headerOnlyDescription": "Đây là thẻ có tiêu đề và mô tả.",
      "headerOnlyTitle": "Chỉ tiêu đề"
    }
  },
  "checkbox": {
    "multi": {
      "description": "Chọn cách bạn muốn nhận thông báo",
      "email": "Email",
      "label": "Tùy chọn thông báo",
      "push": "Thông báo đẩy",
      "sms": "SMS"
    },
    "privacy": "Tôi chấp nhận chính sách bảo mật",
    "terms": "Tôi chấp nhận các điều khoản và điều kiện"
  },
  "collapsible": {
    "blurb": "Phần tử động tạo điều kiện để mở rộng hoặc thu gọn bảng điều khiển.",
    "name": "Có thể thu gọn"
  },
  "components": {
    "errorMessage": "Đã xảy ra lỗi trong thành phần: {{name}}",
    "name": "Thành phần",
    "title": "Thành phần"
  },
  "datePicker": {
    "placeholder": "Chọn ngày",
    "required": "Phải chọn ngày"
  },
  "dialog": {
    "form": {
      "description": "Thực hiện thay đổi hồ sơ của bạn tại đây. Nhấp lưu khi bạn hoàn tất.",
      "nameLabel": "Tên",
      "title": "Chỉnh sửa hồ sơ của bạn",
      "trigger": "Chỉnh sửa hồ sơ",
      "usernameLabel": "Tên người dùng"
    },
    "scrollableContent": {
      "description": "Đây là hộp thoại có nội dung có thể cuộn.",
      "title": "Nội dung có thể cuộn",
      "trigger": "Nội dung có thể cuộn"
    },
    "stickyFooter": {
      "description": "Đây là hộp thoại có nội dung có thể cuộn và chân trang dính.",
      "title": "Chân trang dính",
      "trigger": "Chân trang dính"
    }
  },
  "dropdownMenu": {
    "account": "Tài khoản",
    "billing": "Thanh toán",
    "blurb": "Hiển thị menu cho người dùng — chẳng hạn như một tập hợp các hành động hoặc chức năng — được kích hoạt bởi một nút.",
    "name": "Menu Thả xuống",
    "notifications": "Thông báo",
    "upgrade": "Nâng cấp lên Pro"
  },
  "form": {
    "bioDescription": "Bạn có thể @đề cập người dùng và tổ chức khác.",
    "bioLabel": "Tiểu sử",
    "bioPlaceholder": "Hãy kể cho chúng tôi về bạn",
    "blurb": "Bản demo của tất cả các thành phần đầu vào được bao gồm trong mẫu này.",
    "emailDescription": "Đây là địa chỉ email sẽ được hiển thị trên hồ sơ của bạn.",
    "emailLabel": "Hiển thị email",
    "emailPlaceholder": "Chọn email",
    "name": "Biểu mẫu",
    "nextSubscriptionDateLabel": "Ngày đăng ký tiếp theo",
    "nextSubscriptionDatePlaceholder": "Chọn ngày",
    "nextSubscriptionTimeLabel": "Thời gian đăng ký tiếp theo",
    "nextSubscriptionTimePlaceholder": "Chọn thời gian",
    "notificationsChannelLabel": "Tùy chọn kênh",
    "notificationsSubtitle": "Thông báo",
    "notificationsTypeLabel": "Thông báo tôi về...",
    "otpBlurb": "Nhập mã 6 chữ số được gửi đến <medium>{{phoneNumber}}</medium>",
    "otpDescription": "Bản demo của biểu mẫu có đầu vào OTP cho xác thực.",
    "otpLabel": "Xác minh OTP",
    "otpTitle": "Biểu mẫu OTP",
    "subscriptionSubtitle": "Đăng ký",
    "title": "Biểu mẫu",
    "usernameDescription": "Đây là tên hiển thị công khai của bạn.",
    "usernameLabel": "Tên người dùng",
    "usernamePlaceholder": "Nhập tên người dùng của bạn",
    "validation": {
      "bioTooLong": "Tiểu sử phải có tối đa 140 ký tự",
      "bioTooShort": "Tiểu sử phải có ít nhất 10 ký tự",
      "usernameTooShort": "Tên người dùng phải có ít nhất 3 ký tự"
    }
  },
  "hoverCard": {
    "description": "Đây là thẻ hover. Nó có thể chứa bất kỳ nội dung nào bạn thích, chẳng hạn như văn bản, hình ảnh hoặc thậm chí các thành phần khác.\n\nThẻ hover rất tuyệt vời để cung cấp thông tin bổ sung mà không làm lộn xộn giao diện người dùng. Chúng có thể được sử dụng để hiển thị chú giải công cụ, chi tiết bổ sung hoặc thậm chí các hành động liên quan đến mục được di chuột qua.",
    "title": "Thẻ Hover",
    "trigger": "Di chuột qua tôi"
  },
  "input": {
    "default": "Mặc định",
    "disabled": "Vô hiệu hóa",
    "error": "Có lỗi",
    "file": "Tệp",
    "number": "Số",
    "password": "Mật khẩu",
    "phoneNumber": "Số điện thoại",
    "required": "Bắt buộc",
    "required_label": "Bạn phải nhập trường này",
    "search": "Tìm kiếm"
  },
  "label": {
    "disabled": "Vô hiệu hóa",
    "username": "Tên người dùng"
  },
  "menubar": {
    "edit": "Chỉnh sửa",
    "editMenu": {
      "copy": "Sao chép",
      "cut": "Cắt",
      "find": "Tìm",
      "findOptions": {
        "find": "Tìm...",
        "findNext": "Tìm Tiếp theo",
        "findPrevious": "Tìm Trước đó",
        "searchWeb": "Tìm kiếm trên web"
      },
      "paste": "Dán",
      "redo": "Làm lại",
      "undo": "Hoàn tác"
    },
    "file": "Tệp",
    "fileMenu": {
      "newIncognitoWindow": "Cửa sổ Ẩn danh Mới",
      "newTab": "Tab Mới",
      "newWindow": "Cửa sổ Mới",
      "print": "In...",
      "share": "Chia sẻ",
      "shareOptions": {
        "emailLink": "Gửi liên kết qua email",
        "messages": "Tin nhắn",
        "notes": "Ghi chú"
      }
    },
    "profiles": "Hồ sơ",
    "profilesMenu": {
      "addProfile": "Thêm Hồ sơ...",
      "andy": "Andy",
      "benoit": "Benoit",
      "edit": "Chỉnh sửa...",
      "luis": "Luis"
    },
    "view": "Xem",
    "viewMenu": {
      "alwaysShowBookmarksBar": "Luôn Hiển thị Thanh Dấu trang",
      "alwaysShowFullUrls": "Luôn Hiển thị URL Đầy đủ",
      "forceReload": "Buộc Tải lại",
      "hideSidebar": "Ẩn Thanh bên",
      "reload": "Tải lại",
      "toggleFullscreen": "Chuyển đổi Toàn màn hình"
    }
  },
  "navigationMenu": {
    "backlog": "Tồn đọng",
    "blocks": "Khối",
    "blog": "Blog",
    "blogDescription": "Đọc các bài đăng blog mới nhất của chúng tôi.",
    "components": "Thành phần",
    "componentsDescription": "Duyệt tất cả các thành phần trong thư viện.",
    "documentation": "Tài liệu",
    "documentationDescription": "Tìm hiểu cách sử dụng thư viện.",
    "done": "Hoàn thành",
    "list": "Danh sách",
    "simpleList": "Danh sách Đơn giản",
    "toDo": "Cần làm",
    "withIcons": "Với Biểu tượng"
  },
  "orgName": "Phát triển Mindsea",
  "otpInput": {
    "withCharacters": "Với ký tự",
    "withDigits": "Với chữ số",
    "withDigitsAndCharacters": "Với chữ số và ký tự"
  },
  "progress": {
    "blurb": "Đại diện trực quan cho tiến trình của một tác vụ hoặc quy trình.",
    "name": "Tiến trình"
  },
  "radioGroup": {
    "cardLabel": "Thẻ",
    "comfortable": "Thoải mái",
    "compact": "Gọn",
    "default": "Mặc định",
    "disabledLabel": "Khoảng cách (Vô hiệu hóa)",
    "planDescription": "Chọn kế hoạch phù hợp nhất với nhóm của bạn.",
    "planLabel": "Kế hoạch",
    "proDescription": "Tính năng nâng cao cho các nhóm lớn hơn muốn mở rộng quy mô kinh doanh của họ.",
    "proLabel": "Kế hoạch Pro",
    "spacingLabel": "Khoảng cách",
    "starterDescription": "Hoàn hảo cho các nhóm nhỏ bắt đầu với nền tảng của chúng tôi.",
    "starterLabel": "Kế hoạch Khởi đầu"
  },
  "scrollArea": {
    "photoBy": "Ảnh của <bold>{{artist}}</bold>",
    "tags": "Thẻ"
  },
  "select": {
    "asyncMultiSelectLabel": "Chọn nhiều (async)",
    "asyncMultiSelectPlaceholder": "Chọn Pokémon yêu thích của bạn",
    "asyncSingleSelectLabel": "Chọn đơn (async)",
    "asyncSingleSelectPlaceholder": "Chọn Pokémon yêu thích của bạn",
    "disabled": "Vô hiệu hóa",
    "multiSelectLabel": "Chọn nhiều",
    "multiSelectPlaceholder": "Chọn màu sắc",
    "singleSelectLabel": "Chọn đơn",
    "singleSelectPlaceholder": "Chọn một màu"
  },
  "separator": {
    "blog": "Blog",
    "blurb": "Tạo sự phân biệt trực quan hoặc ngữ nghĩa giữa nội dung.",
    "description": "Bộ phân cách dọc và ngang.",
    "docs": "Tài liệu",
    "name": "Bộ phân cách",
    "source": "Nguồn",
    "title": "Bộ phân cách"
  },
  "sheet": {
    "editProfile": {
      "description": "Thực hiện thay đổi hồ sơ của bạn tại đây. Nhấp lưu khi bạn hoàn tất.",
      "nameLabel": "Tên",
      "title": "Chỉnh sửa hồ sơ",
      "usernameLabel": "Tên người dùng"
    }
  },
  "skeleton": {
    "blurb": "Placeholder đại diện cho cấu trúc của thành phần trong khi nó đang tải.",
    "name": "Khung xương"
  },
  "switch": {
    "airplaneMode": "Chế độ máy bay",
    "bluetooth": "Bluetooth",
    "disabled": "Công tắc bị vô hiệu hóa",
    "required": "Công tắc bắt buộc"
  },
  "table": {
    "caption": "Danh sách các hóa đơn gần đây của bạn",
    "header": {
      "amount": "Số tiền",
      "invoice": "Hóa đơn",
      "method": "Phương thức",
      "status": "Trạng thái"
    },
    "total": "Tổng cộng"
  },
  "tabs": {
    "account": "Tài khoản",
    "accountDescription": "Thực hiện thay đổi tài khoản của bạn tại đây. Nhấp lưu khi bạn hoàn tất.",
    "blurb": "Một tập hợp các phần nội dung phân lớp — được gọi là bảng điều khiển tab — được hiển thị từng cái một.",
    "code": "Mã",
    "currentPasswordLabel": "Mật khẩu hiện tại",
    "disabled": "Vô hiệu hóa",
    "home": "Trang chủ",
    "name": "Tab",
    "nameLabel": "Tên",
    "newPasswordLabel": "Mật khẩu mới",
    "password": "Mật khẩu",
    "passwordDescription": "Thay đổi mật khẩu của bạn tại đây. Sau khi lưu, bạn sẽ được đăng xuất.",
    "preview": "Xem trước",
    "savePasswordCta": "Lưu mật khẩu",
    "settings": "Cài đặt",
    "usernameLabel": "Tên người dùng"
  },
  "text": {
    "blurb": "Typography hệ thống thiết kế",
    "copy": "Con cáo nâu nhanh nhẹn nhảy qua con chó lười biếng.",
    "name": "Văn bản"
  },
  "textarea": {
    "default": "Mặc định",
    "disabled": "Vô hiệu hóa",
    "error": "Có lỗi"
  },
  "theme": {
    "blurb": "Dưới đây là danh sách tất cả các màu trong chủ đề hiện tại.\nChuyển đổi giữa chế độ sáng và tối để xem các màu thích ứng như thế nào.",
    "name": "Chủ đề",
    "paletteTitle": "Bảng màu",
    "title": "Chủ đề",
    "toggle": "Chuyển đổi Chủ đề"
  },
  "title": "Sandbox Thành phần",
  "toast": {
    "action": "Hoàn tác",
    "blurb": "Thông báo không phương thức xuất hiện tạm thời để cung cấp phản hồi cho người dùng.",
    "default": "Sự kiện đã được tạo",
    "description": "Thứ Hai, ngày 3 tháng 1 lúc 6:00 chiều",
    "error": "Không thể tạo sự kiện",
    "info": "Hãy có mặt tại khu vực 10 phút trước thời gian sự kiện",
    "name": "Toast",
    "warning": "Thời gian bắt đầu sự kiện không thể sớm hơn 8 giờ sáng"
  },
  "tooltip": {
    "blurb": "Popup nhỏ cung cấp thông tin bổ sung về một phần tử khi được di chuột qua hoặc được tập trung.",
    "content": "Thêm vào thư viện",
    "default": "Hover",
    "extendedContent": "Để tìm hiểu thêm về cách thức hoạt động của nó, hãy xem tài liệu.\n\nNếu bạn có bất kỳ câu hỏi nào, vui lòng liên hệ với chúng tôi.",
    "info": "Thông tin",
    "name": "Tooltip"
  }
}
